module.exports = __webpack_public_path__ + "static/assets/eed4b27d878e1cd34484e0e7bb1be77e.svg";